import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Input, InputGroup, Row } from "reactstrap";

const dataSearchEmpty = [
  {
    field: "",
    text: "",
    operator: "",
  },
];

const Search = ({ getListagem, setSearch, attributes, search }) => {
  const [preDataSearch, setPreDataSearch] = useState(dataSearchEmpty);
  const [searchButtonDisabled, setSearchButtonDisabled] = useState(true);
  const renderOptionsFields = () => {
    return (
      <>
        <option value="">Selecione um atributo</option>
        {attributes.map((item, index) => {
          return (
            <option value={item.field} key={index}>
              {item.label}
            </option>
          );
        })}
      </>
    );
  };

  const renderOptionsFieldsOperators = (field) => {
    const operators = attributes.find((e) => e.field === field)?.operators;
    if (operators) {
      return (
        <>
          {/* <option value="">Selecione um operador</option> */}
          {operators.map((item, index) => {
            return (
              <option value={item.operator} key={index}>
                {item.label}
              </option>
            );
          })}
        </>
      );
    } else {
      return (
        <>
          <option value="" disabled={true}>
            -
          </option>
        </>
      );
    }
  };

  const setFieldSearch = (value, index) => {
    const _preDataSearch = [...preDataSearch];
    if (_preDataSearch[index].operator === "") {
      _preDataSearch[index].field = value;
      const operators = attributes.find((e) => e.field === value)?.operators;
      if (operators && operators.length > 0) {
        _preDataSearch[index].operator = operators[0].operator;
      }
      setPreDataSearch(_preDataSearch);
    } else {
      _preDataSearch[index].field = value;
      setPreDataSearch(_preDataSearch);
    }
  };

  const setTextSearch = (value, index) => {
    setParamSearch(value, index, "text");
  };

  const setOperatorSearch = (value, index) => {
    setParamSearch(value, index, "operator");
  };

  const setParamSearch = (value, index, param) => {
    const _preDataSearch = [...preDataSearch];
    if (_preDataSearch[index]) {
      _preDataSearch[index][param] = value;
    }
    setPreDataSearch(_preDataSearch);
  };

  const addDataSearch = () => {
    const _preDataSearch = [...preDataSearch];
    _preDataSearch.push(dataSearchEmpty[0]);
    setPreDataSearch(_preDataSearch);
  };

  const removeDataSearch = (index) => {
    const _preDataSearch = [...preDataSearch];
    if (_preDataSearch.length > 1) {
      _preDataSearch.splice(index, 1);
      setPreDataSearch(_preDataSearch);
    } else {
      setPreDataSearch(dataSearchEmpty);
    }
  };

  useEffect(() => {
    const allFieldsFilled = preDataSearch.every((item) => item.text !== "" && item.field !== "" && item.operator !== "");
    setSearchButtonDisabled(!allFieldsFilled);
  }, [preDataSearch]);

  const executeSearch = () => {
    setSearch(preDataSearch);
  };

  useEffect(() => {
    if (search.length === 0) {
      setPreDataSearch(dataSearchEmpty);
    }
  }, [search]);

  useEffect(() => {
    for (const item of preDataSearch) {
      const operators = attributes.find((e) => e.field === item.field)?.operators;
      if (item.field !== "" && item.operator === "") {
        item.operator = [...operators].shift().operator;
      }
    }
  }, [preDataSearch, attributes]);

  const renderFields = () => {
    return preDataSearch.map((item, index) => {
      return (
        <React.Fragment key={index}>
          <Col sm={9} className="my-2">
            <div className="d-flex justify-content-start">
              <InputGroup>
                <Input type="select" className="custom-select" value={item.field} onChange={(e) => setFieldSearch(e.target.value, index)}>
                  {renderOptionsFields()}
                </Input>
                <Input type="select" className="custom-select" value={item.operator} onChange={(e) => setOperatorSearch(e.target.value, index)}>
                  {renderOptionsFieldsOperators(item.field)}
                </Input>
                <Input type="text" className="form-control" placeholder="Buscar por..." value={item.text} onChange={(e) => setTextSearch(e.target.value, index)} />
                <div className="input-group-append">
                  <Button type="button" color="info" onClick={addDataSearch}>
                    <i className="fas fa-plus"></i>
                  </Button>
                </div>
                <div className="input-group-append">
                  <Button type="button" color="danger" onClick={() => removeDataSearch(index)}>
                    <i className="fas fa-trash"></i>
                  </Button>
                </div>
              </InputGroup>
            </div>
          </Col>
          {index + 1 === preDataSearch.length && (
            <Col sm={3} className="my-2">
              <Button type="button" color="info" onClick={() => executeSearch()} disabled={searchButtonDisabled}>
                <i className="fas fa-search"></i> Buscar
              </Button>
            </Col>
          )}
        </React.Fragment>
      );
    });
  };

  return <Row>{renderFields()}</Row>;
};

export default Search;
